import { render } from "./HomeInfoBlock.vue?vue&type=template&id=02409a5f&scoped=true&ts=true"
import script from "./HomeInfoBlock.vue?vue&type=script&lang=ts"
export * from "./HomeInfoBlock.vue?vue&type=script&lang=ts"

import "./HomeInfoBlock.vue?vue&type=style&index=0&id=02409a5f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02409a5f"]])

export default __exports__